export { SerializedMemoryStorageService as MemoryStorageService } from "@bitwarden/storage-core";
